export const getScoreColor = (score: number): string => {
	if (score >= 0.9) {
		return "var(--green)";
	}
	if (score <= 0.5) {
		return "var(--red)";
	}
	return "var(--orange)";
};

export const getScoreBackgroundColor = (score: number): string => {
	if (score >= 0.9) {
		return "var(--green-light)";
	}
	if (score <= 0.5) {
		return "var(--red-light)";
	}
	return "var(--orange-light)";
};